export enum FileDownloadState {
  notStarted,
  starting,
  downloading,
  downloaded
}
